// extracted by mini-css-extract-plugin
module.exports = {"list":"ServicesList_list__jV_yR","group":"ServicesList_group__XsnBp"};